import { useSelector } from 'react-redux'

import type { Collection } from 'reducers/menu-collections/menuCollections'
import { getCollection } from 'selectors/menu-collections/getCollection'

export const useCollection = (id: string | null): Collection | null =>
  useSelector(getCollection(id))
